import { getApiUrl } from './api';
import { apiFetch } from './apiFetch';

const API_URL = getApiUrl();
const PUBLIC_ASSET_PATTERN = /^\/api\/public\/salon\/assets\/[A-Za-z0-9_-]{32}$/;
const ACCEPTED_IMAGE_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);

export const BRANDING_FILE_RULES = {
  logo: {
    maxBytes: 3 * 1024 * 1024,
    maxLabel: '3 MB',
    minDimensions: '128 × 128 px',
  },
  cover: {
    maxBytes: 8 * 1024 * 1024,
    maxLabel: '8 MB',
    minDimensions: '640 × 360 px',
  },
};

const readJson = async (response, fallbackMessage) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || data.message || fallbackMessage);
    error.status = response.status;
    error.code = data.code;
    throw error;
  }
  return data;
};

export const resolveSalonBrandingAssetUrl = (value) => {
  const path = String(value || '').trim();
  return PUBLIC_ASSET_PATTERN.test(path) ? `${API_URL}${path}` : '';
};

const normalizeAsset = (asset) => {
  const url = resolveSalonBrandingAssetUrl(asset?.url);
  return asset && url ? ({ ...asset, url }) : null;
};

export const normalizeSalonBranding = (branding = {}) => ({
  logo: normalizeAsset(branding.logo),
  cover: normalizeAsset(branding.cover),
});

export const validateBrandingFile = (kind, file) => {
  const rules = BRANDING_FILE_RULES[kind];
  if (!rules) return 'Tipo de imagem inválido.';
  if (!file) return 'Selecione uma imagem.';
  if (!ACCEPTED_IMAGE_TYPES.has(String(file.type || '').toLowerCase())) {
    return 'Envie uma imagem JPG, PNG ou WebP.';
  }
  if (Number(file.size || 0) > rules.maxBytes) {
    return `A imagem deve ter no máximo ${rules.maxLabel}.`;
  }
  return '';
};

export const salonBrandingApi = {
  async get() {
    const response = await apiFetch(`${API_URL}/api/salon/branding`, {
      headers: { Accept: 'application/json' },
    });
    const data = await readJson(response, 'Falha ao carregar a identidade da loja.');
    return normalizeSalonBranding(data.branding);
  },

  async save({
    logoFile = null,
    coverFile = null,
    removeLogo = false,
    removeCover = false,
  } = {}) {
    const body = new FormData();
    if (logoFile) body.append('logo', logoFile);
    if (coverFile) body.append('cover', coverFile);
    if (removeLogo) body.append('removeLogo', 'true');
    if (removeCover) body.append('removeCover', 'true');
    const response = await apiFetch(`${API_URL}/api/salon/branding`, {
      method: 'PUT',
      headers: { Accept: 'application/json' },
      body,
    });
    const data = await readJson(response, 'Falha ao salvar a identidade da loja.');
    return normalizeSalonBranding(data.branding);
  },
};
